import dayjs from 'dayjs';
import * as React from 'react';
import BCDatePicker from '../../../BCDatePicker';
import { IPropertyComponentProps, IPropertyItem } from '../../entities';

const defaultStyle: React.CSSProperties = { width: '100%' };

export default function DatePickerProperty(props: IPropertyComponentProps) {
	const replaceValue = (item: IPropertyItem, isoZoneString: string) => {
		if (item && item.key && item.key === 'disabledDates') {
			props.onValueChanged(item, isoZoneString ? [isoZoneString] : null);
		} else if (item.options?.type === 'date') {
			props.onValueChanged(item, convertToDateOnly(isoZoneString));
		} else {
			props.onValueChanged(item, isoZoneString || null);
		}
	};

	const getDateValue = (value?: string) => {
		if (value && typeof value === 'string') {
			return props.item.options
				? dayjs(new Date(value), props.item.options)
				: dayjs(new Date(value));
		} else if (value && typeof value === 'object') {
			return props.item.options
				? dayjs(new Date((value as string[])[0]), props.item.options)
				: dayjs(new Date((value as string[])[0]));
		}
		return null;
	};

	const convertToDateOnly = isoZoneString => {
		if (!isoZoneString) {
			return null;
		}

		return dayjs(isoZoneString).format('YYYY-MM-DD');
	};

	const onChange = (date: dayjs.Dayjs, isoZoneString: string, dateString: string) => {
		props.customChangeEvent
			? props.customChangeEvent(dateString)
			: replaceValue(props.item, isoZoneString);
	};

	return (
		<BCDatePicker
			value={getDateValue(props.value)}
			placeholder={props.item.placeholder}
			onChange={onChange}
			style={props.style || defaultStyle}
			disabled={props.item.disabled || props.item.readOnly}
			readOnly={props.readonly}
			allowClear
			format={props.item.options?.format}
			showTime={props.item.options?.showTime}
			showToday={props.item.options?.showToday}
			size="small"
			getPopupContainer={() => document.body}
		/>
	);
}
